import React from 'react'
import { Link } from 'react-router-dom'
import { SCHOOL_LEGAL_SECTIONS } from '../../content/schoolLegalContent'
import { YOGA_SCHOOL_LEGAL_VERSION } from '../../constants/schoolLegal'

const TermsAndConditions: React.FC = () => (
  <div className="max-w-4xl mx-auto px-4 sm:px-8 py-10">
    <nav className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-gray-500">
        <li>Docs</li>
        <li>/</li>
        <li className="text-gray-900 font-medium">Terms &amp; Conditions</li>
      </ol>
    </nav>

    <h1 className="text-3xl font-bold text-gray-900 mb-2">
      Terms of Service &amp; <span className="text-primary-500">Privacy Policy</span>
    </h1>
    <p className="text-gray-600 mb-4 leading-relaxed">
      For yoga schools using Bookmyyogattc. These terms apply to school owners, administrators, staff, and anyone
      acting on behalf of your school.
    </p>
    <p className="text-sm text-gray-500 mb-8">
      Version {YOGA_SCHOOL_LEGAL_VERSION} · Last updated March 2025
    </p>

    <div className="mb-8 flex flex-wrap gap-4 text-sm">
      <Link
        to="/documentation/payment-terms"
        className="text-primary-600 hover:text-primary-700 hover:underline font-medium"
      >
        Payment terms
      </Link>
      <Link to="/documentation/faq" className="text-primary-600 hover:text-primary-700 hover:underline font-medium">
        FAQ
      </Link>
    </div>

    <div className="space-y-8 text-sm text-gray-600">
      {SCHOOL_LEGAL_SECTIONS.map((section) => (
        <section key={section.id} className="scroll-mt-24" id={section.id}>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{section.title}</h2>
          {section.paragraphs?.map((p) => (
            <p key={p.slice(0, 48)} className="leading-relaxed mb-2">
              {p.includes('info@') ? (
                <>
                  Questions:{' '}
                  <a
                    href="mailto:info@bookmyyogattc.com"
                    className="text-primary-600 hover:text-primary-700 hover:underline"
                  >
                    info@bookmyyogattc.com
                  </a>
                </>
              ) : (
                p
              )}
            </p>
          ))}
          {section.bullets && section.bullets.length > 0 && (
            <ul className="list-disc list-inside space-y-1.5 mt-2">
              {section.bullets.map((b) => (
                <li key={b} className="leading-relaxed">
                  {b}
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  </div>
)

export default TermsAndConditions
